import './App.css';
import React, {useState, useRef, useEffect} from 'react';
import Home from './pages/home/Home';
import Aoa from './pages/404/Aoa';
import About from './pages/about/About';
import Contacto from './pages/contacto/Contacto';
import Modal from './componentes/modal/Modal';
import LangSwitch from './componentes/languageSwitch/langSwitch';
import {Route,Routes} from 'react-router-dom';

import Header from './componentes/header/Header';
import Navbar from './componentes/navbar/Navbar';
import Footer from './componentes/footer/Footer';

function App() {

  const [estadoModal,cambiaEstadoModal] = useState({type:null,on:false,id:null});
  const mainRef = useRef(null);
  const screen = window.screen.width;

  const scrollToworks = () => {
    setTimeout(() => {
      if (!mainRef.current) return;  // evita el error si todavía no carga

      const el = mainRef.current.getBoundingClientRect().top;
      const scr = window.scrollY;
      const targ = scr + el - 90;

      window.scroll({ top: targ, behavior: "smooth" });
    }, 900);
  };
  return (
    <div id="mainT">
      <Modal estado={estadoModal} cambiarEstado={cambiaEstadoModal}></Modal>
      {/* <LangSwitch></LangSwitch> */}
      {screen > 500 ? <Header scroll={scrollToworks}></Header>:<Navbar scroll={scrollToworks}></Navbar>}
      {/* <Header scroll={scrollToworks}></Header>
      <Navbar scroll={scrollToworks}></Navbar> */}
      <Routes>
        <Route path='' element={<Home />}></Route>
        <Route path='/' element={<Home />}></Route>
        <Route path='/Home' element={<Home mainref={mainRef} />}></Route>
        <Route path='/About' element={<About />}></Route>
        <Route path='/Contacto' element={<Contacto />}></Route>
        <Route path='*' element={<Aoa />}></Route>
      </Routes>
      {/* <Footer></Footer> */}
    </div>
  );
}

export default App;
